<template>
    <div>
        <college-banner></college-banner>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <CollegeSideNavLayout></CollegeSideNavLayout>
                </div>
                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="db-stat-box">
                                <div class="stat-details">
                                    <div class="db-stat-icon">
                                        <i class="far fa-newspaper"></i>
                                    </div>
                                    <div class="db-stat-count">{{ stats.recommended_count }} <span>Posts Recommended</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="db-stat-box">
                                <div class="stat-details">
                                    <div class="db-stat-icon">
                                        <i class="fas fa-thumbs-up"></i>
                                    </div>
                                    <div class="db-stat-count">{{ stats.likes_count }} <span>Posts Liked</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="db-stat-box">
                                <div class="stat-details">
                                    <div class="db-stat-icon">
                                        <i class="fas fa-thumbs-down"></i>
                                    </div>
                                    <div class="db-stat-count">{{ stats.dislikes_count }} <span>Posts Dislikes</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="divider"></div>
                    <div class="row">
                        <div class="col-md-6" v-for="feed in feedData">
                            <div class="feed-box dash-inner-box">
                                <router-link :to="{path: '/dashboard/skill-up-detail?id=' + feed.post_enc_id}">
                                    <div class="rec-batch" v-if="feed.is_recommended">Recommended</div>
                                    <div class="feed-img">
                                        <img :src="feed.cover_image" v-if="feed.cover_image">
                                        <img :src="feed.post_image_url" v-else-if="feed.post_image_url">
                                    </div>
                                </router-link>
                                <h3 class="feed-heading">
                                    <router-link :to="{path: '/dashboard/skill-up-detail?id=' + feed.post_enc_id}">
                                        {{ feed.post_title }}
                                    </router-link>
                                </h3>
                                <div class="author-s">
                                    <div class="author list-data" v-if="feed.skillsUpAuthors.length"><i class="fas fa-user"></i><span v-for="au in feed.skillsUpAuthors"> {{ au.name }}</span></div>
                                    <div class="source"><i class="fas fa-link"></i><Span> {{ feed.source_name }}</Span>
                                    </div>
                                </div>
                                <p class="feed-content" v-html="feed.post_short_summery">
                                </p>
                                <div class="feed-btns">
<!--                                    <a href="#demo" data-toggle="collapse" class="show-data"><i class="fas fa-chevron-down"></i></a>-->
<!--                                    <div id="demo" class="collapse data-show-col">-->
<!--                                        hello-->
<!--                                    </div>-->
                                    <div class="like-dis">
                                        <a href="javascript:;" class="like-btn default" title="Like"
                                           :data-key="feed.post_enc_id" @click="likeThisPost($event,1)"
                                           v-if="feed.feedback_status == 0"><i class="fa fa-thumbs-up"></i></a>
                                        <a href="javascript:;" class="like-btn" title="Like"
                                           :data-key="feed.post_enc_id" @click="likeThisPost($event,0)"
                                           v-if="feed.feedback_status == 1"><i class="fa fa-thumbs-up"></i></a>
                                        <a href="javascript:;" class="recommend-student default" :data-key="feed.post_enc_id" title="Recommend To Students" v-if="!feed.teacher_recommended" @click="recommendToStudent($event)">
                                            <i class="fas fa-retweet"></i>
                                        </a>
                                        <a href="javascript:;" class="recommend-student" :data-key="feed.post_enc_id" title="Recommended To Students" v-else-if="feed.teacher_recommended" @click="recommendToStudent($event)">
                                            <i class="fas fa-retweet"></i>
                                        </a>
                                    </div>
                                    <div class="feed-share">
                                        <a href="javascript:;" class="fb"
                                           onclick="window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                            <i class="fab fa-facebook-f"></i>
                                        </a>
                                        <a href="javascript:;" class="wts-app"
                                           onclick="window.open('https://api.whatsapp.com/send?text=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                            <i class="fab fa-whatsapp"></i>
                                        </a>
                                        <a href="javascript:;"
                                           onclick="window.open('https://twitter.com/intent/tweet?text=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');"
                                           class="tw">
                                            <i class="fab fa-twitter"></i>
                                        </a>
                                        <a href="javascript:;" class="male"
                                           onclick="window.open('https://www.linkedin.com/shareArticle?mini=true&amp;url=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                            <i class="fab fa-linkedin"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CollegeSideNavLayout from "../../components/CollegeSideNavLayout";
    import collegeBanner from "../../components/collegeBanner";
    import axios from "axios";
    import {requestHeaders} from "../../_helpers/apiHelper";

    export default {
        components: {
            CollegeSideNavLayout,
            collegeBanner
        },
        data() {
            return {
                feedData: [],
                request: true,
                bottom: false,
                loadMore: true,
                isLoadingFeed: false,
                page: 1,
                stats: 1,
            }
        },
        mounted() {
            this.getFeed();
            this.getStats();
        },
        methods: {
            getFeed() {
                if (this.request && this.loadMore) {
                    this.loadMore = false;
                    this.isLoadingFeed = true;
                    var t = this;
                    var url = this.$store.getters.getDomain;

                    // var coursesElem = document.getElementsByName('courses');
                    // var coursesArray = [];
                    // for (var c = 0; c < coursesElem.length; c++) {
                    //     if (coursesElem[c].checked) {
                    //         coursesArray.push(coursesElem[c].value);
                    //     }
                    // }
                    axios.post(`${url}api/v2/skill-up/teacher-recommended-posts`, {
                        page: t.page,
                        // content_type: coursesArray,
                        keyword:t.sKeyword
                    }, {headers: requestHeaders()}).then(function (response) {
                        t.isLoadingFeed = false;
                        if (response['data']['response']['status'] == 200) {
                            for (var i = 0; i < response['data']['response']['data'].length; i++) {
                                t.feedData.push(response['data']['response']['data'][i]);
                            }
                            t.loadMore = true;
                        } else {
                            t.request = false;
                        }
                    });
                }
            },
            getStats() {
                var t = this;
                var url = this.$store.getters.getDomain;

                axios.post(`${url}api/v2/skill-up/get-teacher-stats`, "", {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.stats = response['data']['response']['counts'];
                    }
                });
            },
            likeThisPost(event, action) {
                var t = this;
                var element = event.currentTarget;
                var data_key = element.getAttribute('data-key');
                for (var i = 0; i < t.feedData.length; i++) {
                    if (t.feedData[i].post_enc_id == data_key) {
                        t.feedData[i].feedback_status = action;
                        break;
                    }
                }
                var url = this.$store.getters.getDomain;

                axios.post(`${url}api/v2/skill-up/post-like-dislike`, {
                    post_id: data_key,
                    action: action
                }, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] != 200) {
                        var tempData;
                        if (action == 1) {
                            tempData = 0;
                        } else {
                            tempData = 1
                        }
                        for (var i = 0; i < t.feedData.length; i++) {
                            if (t.feedData[i].post_enc_id == data_key) {
                                t.feedData[i].feedback_status = tempData;
                                break;
                            }
                        }
                        // alert('An error occurred while liking the post, please try again later.');
                    }
                });
            },
            recommendToStudent(event) {
                var t = this;
                var element = event.currentTarget;
                var data_key = element.getAttribute('data-key');
                for (var i = 0; i < t.feedData.length; i++) {
                    if (t.feedData[i].post_enc_id == data_key) {
                        if(t.feedData[i].teacher_recommended){
                            t.feedData[i].teacher_recommended = false;
                        } else {
                            t.feedData[i].teacher_recommended = true
                        }
                        break;
                    }
                }
                var url = this.$store.getters.getDomain;

                axios.post(`${url}api/v2/skill-up/save-recommended-post`, {
                    post_id: data_key,
                }, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] != 200) {
                        for (var i = 0; i < t.feedData.length; i++) {
                            if (t.feedData[i].post_enc_id == data_key) {
                                if(t.feedData[i].teacher_recommended){
                                    t.feedData[i].teacher_recommended = false;
                                } else {
                                    t.feedData[i].teacher_recommended = true
                                }
                                break;
                            }
                        }
                        // alert('An error occurred while liking the post, please try again later.');
                    }
                });
            },
            bottomVisible() {
                const scrollY = window.scrollY
                const visible = document.documentElement.clientHeight
                const pageHeight = document.documentElement.scrollHeight;

                const bottomOfPage = visible + scrollY >= pageHeight - 200;
                return bottomOfPage;
            },
            loaderShow() {
                var fadeTarget = document.getElementById("h-page-loading");
                var fadeEffect = setInterval(function () {
                    if (!fadeTarget.style.opacity) {
                        fadeTarget.style.opacity = 0;
                    }
                    if (fadeTarget.style.opacity == 0) {
                        fadeTarget.style.opacity = 0.7;
                    } else {
                        clearInterval(fadeEffect);
                        fadeTarget.style.display = "block";
                    }
                }, 100);
            },
            loaderHide() {
                var fadeTarget = document.getElementById("h-page-loading");
                var fadeEffect = setInterval(function () {
                    if (!fadeTarget.style.opacity) {
                        fadeTarget.style.opacity = 1;
                    }
                    if (fadeTarget.style.opacity > 0) {
                        fadeTarget.style.opacity -= 0.1;
                    } else {
                        clearInterval(fadeEffect);
                        fadeTarget.style.display = "none";
                    }
                }, 100);
            },
        },
        watch: {
            bottom(bottom) {
                if (bottom) {
                    this.page += 1;
                    this.getFeed()
                }
            }
        },
        created() {
            window.addEventListener('scroll', () => {
                this.bottom = this.bottomVisible()
            })
        }
    }
</script>

<style scoped>
    .show-data[data-v-bacc6b0c] {
        position: absolute;
        top: -2px;
        left: 45%;
        background-color: #00a0e3;
        color: #fff;
        padding: 0 15px;
        border-radius: 0 0 4px 4px;
        z-index: 999;
    }
    .data-show-col {
        position: absolute;
        background-color: rgb(255, 255, 255);
        z-index: 1;
        width: 100%;
        top: -1px;
        padding: 5px;
        height: 38px;
    }
    .feed-box {
        padding: 20px 20px 15px 20px;
        margin-bottom: 30px;
        position: relative;
    }

    .rec-batch {
        position: absolute;
        right: 25px;
        top: 25px;
        background-color: #fff;
        padding: 5px 8px;
        font-family: roboto;
        font-size: 11px;
        text-transform: uppercase;
        font-weight: 500;
    }

    .feed-img img {
        width: 100%;
        object-fit: cover;
        min-height: 200px;
        max-height: 200px;
    }

    .feed-heading a {
        font-size: 18px;
        font-family: roboto;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        cursor: pointer;
        color: #000;
    }

    .author-s {
        display: flex;
        align-items: center;
        font-family: roboto;
    }

    .author, .source {
        margin-right: 10px;
        color: #fff;
        padding: 4px 8px;
        margin-bottom: 10px;
    }

    .author {
        background-color: #00a0e3;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 19px;
        height: 24.8px;
    }

    .source {
        background-color: #ff7803;
        flex: none;
    }

    .feed-content {
        text-align: justify;
        font-size: 14px;
        font-family: roboto;
        line-height: 22px;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        height: 90px;
    }

    .feed-btns {
        display: flex;
        border-top: 2px solid #eee;
        padding: 10px 0 0;
        flex-wrap: wrap;
        justify-content: space-between;
        position: relative;
    }

    .like-dis {
        flex-basis: 50%;
    }

    .feed-share {
        text-align: right;
        display: flex;
        justify-content: space-between;
        flex-basis: 22%;
        align-items: center;
    }

    .like-btn {
        color: #00a0e3;
        font-size: 20px;
    }

    .recommend-student {
        font-size: 20px;
        margin-left: 15px;
        color: #00a0e3;
    }

    .like-btn.default,.recommend-student.default {
        color: #aaa;
    }

    .wts-app, .fb, .tw, .male {
        width: 25px;
        text-align: center;
        border-radius: 50px;
        height: 25px;
        font-size: 15px;
        padding-top: 3px;
        margin-right: 5px;
    }

    .wts-app {
        background-color: #25D366;
    }

    .male {
        background-color: #d3252b;
    }

    .tw {
        background-color: #1c99e9;
    }

    .fb {
        background-color: #236dce;
    }

    .wts-app i, .male i, .tw i, .fb i {
        color: white;
        font-size: 14px;
        cursor: pointer;
    }
</style>
